 
namespace TabAurous.Sales {
    import fld = SalesReturnItemsBOMRow.Fields;
    @Serenity.Decorators.registerClass()
    export class SalesReturnItemsBOMEditor extends _Ext.BOMGridEditor<SalesReturnItemsBOMRow> { 
        protected getDialogType() { return SalesReturnItemsBOMDialog; }
        protected getLocalTextPrefix() { return SalesReturnItemsBOMRow.localTextPrefix; } 
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));      
            this.slickGrid.setOptions({ rowHeight: 30 });
        } 
        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        }

    }
}